import { formatPhoneNumber } from 'noddi-util';
import { driverName, type DriverContact } from './driversForCars';

export const DriversCell = ({ drivers }: { drivers: DriverContact[] }) => {
  if (drivers.length === 0) {
    return null;
  }

  return (
    <div className='flex flex-col gap-3'>
      {drivers.map((driver) => {
        const name = driverName(driver);
        return (
          <div key={driver.userId} className='flex flex-col'>
            {name ? <div>{name}</div> : null}
            {driver.phoneNumber ? (
              <div className='text-xs text-muted-foreground'>{formatPhoneNumber(driver.phoneNumber)}</div>
            ) : null}
            {driver.email ? <div className='text-xs text-muted-foreground'>{driver.email}</div> : null}
          </div>
        );
      })}
    </div>
  );
};
